"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The GlobalNotificationCreate model module.
 * @module model/GlobalNotificationCreate
 * @version 0.0.1
 */
class GlobalNotificationCreate {
  /**
   * Constructs a new <code>GlobalNotificationCreate</code>.
   * @alias module:model/GlobalNotificationCreate
   * @param nutzerId {String} 
   * @param neuigkeitenKfv {Boolean} 
   * @param neuigkeitenKjf {Boolean} 
   * @param fortbildungKfv {Boolean} 
   * @param fortbildungKjf {Boolean} 
   * @param stellenanzeige {Boolean} 
   */
  constructor(nutzerId, neuigkeitenKfv, neuigkeitenKjf, fortbildungKfv, fortbildungKjf, stellenanzeige) {
    GlobalNotificationCreate.initialize(this, nutzerId, neuigkeitenKfv, neuigkeitenKjf, fortbildungKfv, fortbildungKjf, stellenanzeige);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, nutzerId, neuigkeitenKfv, neuigkeitenKjf, fortbildungKfv, fortbildungKjf, stellenanzeige) {
    obj['nutzer_id'] = nutzerId;
    obj['neuigkeiten_kfv'] = neuigkeitenKfv;
    obj['neuigkeiten_kjf'] = neuigkeitenKjf;
    obj['fortbildung_kfv'] = fortbildungKfv;
    obj['fortbildung_kjf'] = fortbildungKjf;
    obj['stellenanzeige'] = stellenanzeige;
  }

  /**
   * Constructs a <code>GlobalNotificationCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GlobalNotificationCreate} obj Optional instance to populate.
   * @return {module:model/GlobalNotificationCreate} The populated <code>GlobalNotificationCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GlobalNotificationCreate();
      if (data.hasOwnProperty('nutzer_id')) {
        obj['nutzer_id'] = _ApiClient.default.convertToType(data['nutzer_id'], 'String');
      }
      if (data.hasOwnProperty('neuigkeiten_kfv')) {
        obj['neuigkeiten_kfv'] = _ApiClient.default.convertToType(data['neuigkeiten_kfv'], 'Boolean');
      }
      if (data.hasOwnProperty('neuigkeiten_kjf')) {
        obj['neuigkeiten_kjf'] = _ApiClient.default.convertToType(data['neuigkeiten_kjf'], 'Boolean');
      }
      if (data.hasOwnProperty('fortbildung_kfv')) {
        obj['fortbildung_kfv'] = _ApiClient.default.convertToType(data['fortbildung_kfv'], 'Boolean');
      }
      if (data.hasOwnProperty('fortbildung_kjf')) {
        obj['fortbildung_kjf'] = _ApiClient.default.convertToType(data['fortbildung_kjf'], 'Boolean');
      }
      if (data.hasOwnProperty('stellenanzeige')) {
        obj['stellenanzeige'] = _ApiClient.default.convertToType(data['stellenanzeige'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>GlobalNotificationCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GlobalNotificationCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of GlobalNotificationCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['nutzer_id'] && !(typeof data['nutzer_id'] === 'string' || data['nutzer_id'] instanceof String)) {
      throw new Error("Expected the field `nutzer_id` to be a primitive type in the JSON string but got " + data['nutzer_id']);
    }
    return true;
  }
}
GlobalNotificationCreate.RequiredProperties = ["nutzer_id", "neuigkeiten_kfv", "neuigkeiten_kjf", "fortbildung_kfv", "fortbildung_kjf", "stellenanzeige"];

/**
 * @member {String} nutzer_id
 */
GlobalNotificationCreate.prototype['nutzer_id'] = undefined;

/**
 * @member {Boolean} neuigkeiten_kfv
 */
GlobalNotificationCreate.prototype['neuigkeiten_kfv'] = undefined;

/**
 * @member {Boolean} neuigkeiten_kjf
 */
GlobalNotificationCreate.prototype['neuigkeiten_kjf'] = undefined;

/**
 * @member {Boolean} fortbildung_kfv
 */
GlobalNotificationCreate.prototype['fortbildung_kfv'] = undefined;

/**
 * @member {Boolean} fortbildung_kjf
 */
GlobalNotificationCreate.prototype['fortbildung_kjf'] = undefined;

/**
 * @member {Boolean} stellenanzeige
 */
GlobalNotificationCreate.prototype['stellenanzeige'] = undefined;
var _default = exports.default = GlobalNotificationCreate;